import { Empty, RefSelectProps, Select, SelectProps } from 'antd';
import { forwardRef, ForwardRefRenderFunction, useState } from 'react';
import PageSpinner from '../../../../shared/components/page-spinner/page-spinner';
import { useGetTemplatesQuery } from '../../api/templates-api';
import { useTranslation } from 'react-i18next';

type Props = Omit<SelectProps, 'filterOption' | 'showSearch' | 'onSearch' | 'onBlur'>;

const TemplateSelect: ForwardRefRenderFunction<RefSelectProps, Props> = (props, ref): JSX.Element => {
  const { data: templates, isFetching: isTemplatesFetching } = useGetTemplatesQuery();
  const { t } = useTranslation('templates');
  const [open, setOpen] = useState(false);
  const { onChange: parentOnChange, ...restProps } = props;

  const handleChange: SelectProps['onChange'] = (value, option) => {
    if (props.maxCount && props.maxCount <= value.length) {
      setOpen(false);
    } else {
      setOpen(true);
    }

    if (parentOnChange) {
      parentOnChange(value, option);
    }
  };

  return (
    <Select
      ref={ref}
      allowClear={true}
      showSearch={{
        filterOption: (inputValue, option) =>
          (option?.children ?? '').toString().toLowerCase().includes(inputValue.toLowerCase()),
      }}
      open={open}
      onOpenChange={visible => setOpen(visible)}
      placeholder={t('templateSelect.selectTemplate')}
      onChange={handleChange}
      notFoundContent={isTemplatesFetching ? <PageSpinner /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      {...restProps}
    >
      {templates?.map(({ id, name }) => (
        <Select.Option key={id} value={id}>
          {name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default forwardRef(TemplateSelect);
